import i18n from '@/plugins/i18n';

const getDefaultTabsState = (rootState, rootGetters) => {
  return [
    { name: 'attributes', verboseName: i18n.t('sidebar.attributes'), isVisible: true },
    ...(rootGetters['admin/isPermitted']({ module: 'ORDERS_MODULE', setting: 'orders_module_enabled' })
      ? [{ name: 'orders', verboseName: i18n.t('sidebar.ordersTab'), isVisible: true }]
      : []),
    ...(rootGetters['admin/isPermitted']({ module: 'CASES' })
      ? [
          {
            name: 'cases',
            verboseName: rootState.admin.settingsValues.case_info_text || i18n.t('sidebar.cases'),
            isVisible: true,
          },
        ]
      : []),
    { name: 'notes', verboseName: i18n.t('sidebar.notes'), isVisible: true },
    { name: 'attachments', verboseName: i18n.t('sidebar.attachments'), isVisible: true },
    { name: 'relations', verboseName: i18n.t('sidebar.relations'), isVisible: true },
    { name: 'changeHistory', verboseName: i18n.t('sidebar.changeHistory'), isVisible: true },
    ...(rootGetters['admin/isPermitted']({ module: 'UPDATE_SUGGESTIONS_MODULE' })
      ? [{ name: 'suggestions', verboseName: i18n.t('sidebar.suggestions'), isVisible: true }]
      : []),
  ];
};

const getters = {
  getFeatureTabsConfig:
    (_, __, rootState, rootGetters) =>
    (config = null) => {
      const defaultTabsState = getDefaultTabsState(rootState, rootGetters);
      if (config) {
        const mappedConfig = config.map(tab => {
          return { ...defaultTabsState.find(defaultTab => defaultTab.name === tab.name), ...tab };
        });
        const defaultTabsNotInConfig = defaultTabsState.filter(
          defaultTab => !mappedConfig.find(tab => tab.name === defaultTab.name)
        );
        return [...mappedConfig, ...defaultTabsNotInConfig];
      } else return defaultTabsState;
    },
  getFeatureTabs:
    (_, getters) =>
    (config = null) => {
      const featureTabsConfig = getters.getFeatureTabsConfig(config);
      return featureTabsConfig.filter(tab => tab.isVisible).map(tab => tab.name);
    },
};

export default {
  namespaced: true,
  getters,
};
